import { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { getCollection } from 'store/reducers/content';
import { setContent } from 'actions/content-actions';
import graphql from 'api/graphql';
import logger from 'util/logger';

export default function useFetchData({
  contentTypeId,
  slug,
  subSlug,
  onError,
  options,
  config,

  store,
} = {}) {
  const [state, setState] = useState({ isLoading: !!slug, data: null, error: false });
  const dispatch = useDispatch();

  const dataFromStore = useSelector(getCollection(slug));

  useEffect(() => {
    let unmounted;

    async function fetchData() {
      try {
        const fetchFromGraphql = graphql.getFetchFunction(contentTypeId);

        const data = await fetchFromGraphql({
          slug,
          subSlug,
          // Remove contentTypeId after overview query cleanup
          contentTypeId,
          options,
          config,
        });
        if (!unmounted) {
          if (store) {
            const collection = {};
            collection[slug] = data;
            dispatch(setContent(collection, contentTypeId));
          }
          setState({ data, error: false, isLoading: false });
        }
      } catch (graphqlError) {
        if (!unmounted) {
          setState({ data: null, error: true, isLoading: false });
        }
        if (onError) {
          onError(slug);
        }
        logger.error(`Error ${graphqlError} while fetchData with graphQL for ${slug} | ${contentTypeId}`);
      }
    }

    if (slug && contentTypeId) {
      if (dataFromStore) {
        setState({ data: dataFromStore, error: false, isLoading: false });
      } else {
        fetchData();
      }
    }

    return () => {
      unmounted = true;
    };
  }, [slug, subSlug]);

  return state;
}
